export const API_URL=process.env.REACT_APP_API_ENDPOINT;
export const ENV="dev";
export const VERSION="0.0.1";
export const DEFAULT_LANG="fr-FR";
export const LOADINGBAR_COLOR="#1e6abc";
export const DEFAULT_CURRENCY="€";
